import {dark} from './dark';
import {tradeShow} from './tradeShow';
import {light} from './light';

export const templates = {
  dark,
  tradeShow,
  light
};



// WEBPACK FOOTER //
// ./styles/themes/index.js